import React, { FC, useCallback, useContext, useRef } from 'react';
import { Form, Cascader, Button, Select, FormInstance, DatePicker } from 'antd';
import { VerifyFormValues } from './interface';
import styles from './home.module.less';
import { homeContext } from './context';
import { Gender, LabelType } from '@/enum';
import { url } from '@/url';
import { useHistory } from 'react-router-dom';

export const VerifyForm: FC = () => {
  const {
    commonFormItemProps,
    categoryCascaderOptionsState,
    genderDesignerOptionsDictState,
    labelerListState,
  } = useContext(homeContext);

  const formRef = useRef<FormInstance>();

  const checkFormValue = useCallback(() => {
    const form = formRef.current;
    const { category, brand } = form.getFieldsValue();
    const gender: Gender = category?.[0];
    if (gender && brand && !genderDesignerOptionsDictState.data[gender].includes(brand)) {
      form.setFieldsValue({
        brand: '',
      });
    }
  }, []);


  const history = useHistory();
  const onStartVerify = useCallback(
    ({ category: [gender, c1, c2], labeler, brand, range }: VerifyFormValues) => {
      const [start, end] = range || [undefined, undefined];
      history.push(url.label({ gender, c1, c2, type: LabelType.Verify }, {
        labeler: labeler || undefined,
        brand: brand || undefined,
        start: start && start.startOf('day').format('YYYY-MM-DD'),
        end: end && end.endOf('day').format('YYYY-MM-DD'),
      }));
    },
    [history]
  );

  return (<Form<VerifyFormValues> ref={formRef} initialValues={{
    category: undefined,
    labeler: '',
    brand: '',
    range: undefined,
  }} onValuesChange={checkFormValue} className={styles.form} size="large" onFinish={onStartVerify}>
    <Form.Item
      {...commonFormItemProps}
      label="类别"
      name="category"
      required
      rules={[{ required: true, message: '请选择类别' }]}
    >
      <Cascader placeholder="请选择商品类别" options={categoryCascaderOptionsState.data} />
    </Form.Item>
    <Form.Item {...commonFormItemProps} label="标注账号" name="labeler" >
      <Select placeholder="选择需要指定审核的标注账号" loading={labelerListState.loading}>
        <Select.Option value="">全部</Select.Option>
        {labelerListState.data.map(labeler => (
          <Select.Option key={labeler} value={labeler}>
            {labeler}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item name="brand" noStyle />
    <Form.Item<VerifyFormValues> label="品牌"  {...commonFormItemProps} shouldUpdate={() => true} >
      {
        ({ getFieldValue, setFieldsValue }) => {
          const gender = getFieldValue('category')?.[0];
          const designerOptions = genderDesignerOptionsDictState.data[gender] || [];
          const designerValue = getFieldValue('brand');
          const onChangeDesignerValue = (brand: string) => setFieldsValue({
            brand,
          });
          return (
            <Select showSearch filterOption={(input, option) =>
              !option.value.toLowerCase().indexOf(input.toLowerCase())
            } value={designerValue} onChange={onChangeDesignerValue} placeholder="选择需要指定审核的品牌名称" loading={genderDesignerOptionsDictState.loading} >
              <Select.Option value="">全部</Select.Option>
              {
                designerOptions.map(designer => (
                  <Select.Option key={designer} value={designer}>
                    {designer}
                  </Select.Option>
                ))
              }
            </Select>
          )
        }
      }
    </Form.Item>
    <Form.Item {...commonFormItemProps} label="标注日期" name="range">
      <DatePicker.RangePicker placeholder={['开始日期', '结束日期']} />
    </Form.Item>
    <Button htmlType="submit" type="primary" size="large" className={styles.button}>
      开始审核
    </Button>
  </Form>)

}